import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent implements OnInit {
  @Input() public name: string

  constructor() {}

  ngOnInit() {}
}
